import { render, staticRenderFns } from "./LoginInterface.vue?vue&type=template&id=2b26a0f8&scoped=true&"
import script from "./LoginInterface.vue?vue&type=script&lang=ts&"
export * from "./LoginInterface.vue?vue&type=script&lang=ts&"
import style0 from "./LoginInterface.vue?vue&type=style&index=0&id=2b26a0f8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b26a0f8",
  null
  
)

export default component.exports